module.exports = __webpack_public_path__ + "static/img/404.327302a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/404.jpg
// module id = 8au4
// module chunks = 1